import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberScreen } from '@/lib/screenTracker';

// Renders nothing; records the last visited app section for the AI Assistant.
export const RouteTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    rememberScreen(pathname);
  }, [pathname]);
  return null;
};
